module.exports = __webpack_public_path__ + "NanumSquareB.e850eb664f41c0828a8a";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareB.ttf
// module id = ../../../../../src/assets/font/NanumSquareB.ttf
// module chunks = styles